<template>
  <div class="container">
    <mt-header fixed title="订单详情" class="head">
      <div slot="left" @click="toBackClick">
        <mt-button icon="back"></mt-button>
      </div>
      <mt-button slot="right" v-show="!(state==1)" @click="cancelOrder">
        <i class="iconfont icon-sangedian"></i>
      </mt-button>
    </mt-header>
    <div class="title">
      <div class="c_m_t_10">
        <div class="c_center c_red c_nowrap uname">
          ¥{{totalmny?totalmny:0}}
          <!--<span class="c_white" style="">{{state==1?'已接单':'待接单'}}</span>-->
        </div>
      </div>
    </div>
    <div class="select c_m_t_10">
      <mt-navbar class="" v-model="selected">
        <mt-tab-item id="1">细项明细</mt-tab-item>
        <mt-tab-item v-show="!(state==1)" id="2">物料明细</mt-tab-item>
      </mt-navbar>
    </div>
    <div class="select-item c_m_t_10">
      <div class="c_p_10" v-show="selected == 1">
        <div class="c_flex">
          <div class="c_p_10 c_flex_1 c_center">细项名称</div>
          <div class="c_p_10 c_flex_1 c_center">单价(元)</div>
          <div class="c_p_10 c_flex_1 c_center">数量</div>
        </div>
        <div class="c_flex bg_white c_m_t_1 c_break_all" v-for="(item,index) in material" :key="index">
          <div class="c_p_10 c_flex_1 c_center c_flex c_flex_center">{{item.itemname}}</div>
          <div class="c_p_10 c_flex_1 c_center c_flex c_flex_center">
            {{item.price}}
            <!--<span v-if="item.unit && item.unit != '百分比'"> /{{item.unit}}</span>
            <span v-else-if="item.unit == '百分比'"> %</span>-->
          </div>
          <div class="c_p_10 c_flex_1 c_center c_flex c_flex_center">{{item.num}}</div>
        </div>
        <div class="c_flex c_flex_center bg_white c_m_t_1" v-show="material.length<1">
          <div class="c_gray">没有细项明细</div>
        </div>
      </div>
      <div class="c_p_10" v-show="selected == 2">
        <div class="c_flex">
          <div class="c_p_10 c_center c_flex_1">物料名称</div>
          <div class="c_p_10 c_center c_flex_1">物料明细(单价/元)</div>
          <div class="c_p_10 c_center c_flex_1">物料数量</div>
          <div class="c_p_10 c_center c_flex_1">单位</div>
          <div class="c_p_10 c_center c_flex_1">规格</div>
        </div>
        <div class="c_flex bg_white c_m_t_1 c_break_all" v-for="(item,index) in product" :key="index">
          <div class="c_p_10 c_center c_flex_1 c_flex c_flex_center">{{item.material}}</div>
          <div class="c_p_10 c_center c_flex_1 c_flex c_flex_center">{{item.price}}</div>
          <div class="c_p_10 c_center c_flex_1 c_flex c_flex_center">{{item.num}}</div>
          <div class="c_p_10 c_center c_flex_1 c_flex c_flex_center">{{item.unit}}</div>
          <div class="c_p_10 c_center c_flex_1 c_flex c_flex_center">{{item.spec}}</div>
        </div>
        <div class="c_flex c_flex_center bg_white c_m_t_1" v-show="product.length<1">
          <div class="c_gray">没有物料明细</div>
        </div>
      </div>
    </div>
    <!--取消订单-->
    <mt-actionsheet
      :actions="type_params.actions"
      v-model="type_params.type_visible">
    </mt-actionsheet>
  </div>
</template>

<script>
  export default {
    name: "orderDetail",
    data() {
      return {
        selected: "1",
        billid: '',
        serviceid: '',
        state: 0,
        totalmny: 0,
        material: {},
        product: {},
        // 取消订单
        type_params: {
          type_visible: false,
          actions: [
            {
              name: '取消订单',
              method: this.tapCancel,
            }
          ],
        },
      }
    },
    mounted: function () {
      var id = this.$route.query.id;
      var state = this.$route.query.state;
      if (!id) {
        this.$router.push('/order');
      } else {
        this.billid = id;
        this.state = state;
        this.loadList();
      }
    },
    methods: {
      loadList: function () {
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getOrderDetail, {
          orderid: this.billid
        }, function (res) {
          var msg = res.data.detailMsg.data;
          if (msg) {
            $that.totalmny = msg.totalmny;
            $that.state = msg.state;
            $that.serviceid = msg.serviceid;
            // 细项
            $that.material = msg.id_billorderproductbody || [];
            // 物料
            $that.product = msg.id_billordermaterialbody || [];
          }
        });
      },
      // 取消订单
      cancelOrder: function () {
        this.type_params.type_visible = true;
      },
      tapCancel: function () {
        var $that = this;
        $that.$messagebox.confirm('确定要取消订单吗?').then(action => {
          $that.$indicator.open({
            spinnerType: 'fading-circle'
          });
          $that.$messagebox.prompt('请输入订单取消原因','提示',{inputPlaceholder:'请输入50字以内的原因'}).then(({value, action}) => {
          // $that.$messagebox.prompt('请输入订单取消原因').then(({value, action}) => {
            if (action == 'confirm') {
              if (value) {
                value = value.substring(0, 50);
              }
              $that.$ajax.post($that.$$api.mobile.cancelOrder, {
                orderid: $that.billid,
                serviceid: $that.serviceid,
                reason: value||'',
              }, function (res) {
                if (res) {
                  $that.$indicator.close();
                  $that.$toast({message: '订单已取消', iconClass: 'icon icon-success'});
                  $that.$router.push('/order');
                }
              });
            }
          });
        });
      },
      toBackClick:function () {
        this.$router.go(-1);
      },
    },
  };
</script>

<style scoped>
  .container {
    /*background: #f7f7f7;*/
  }

  .uname {
    font-size: 12vw;
  }

  .uname span {
    font-size: 4vw;
    background: #aaa;
    padding: 1vw 2vw;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetail.vue